import * as icons from 'lucide-react';
import { FC } from 'react';

const toPascalCase = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export const LucideIconCell: FC<{ name?: string }> = ({ name }) => {
	if (!name) return null;
	const Icon = (icons as any)[toPascalCase(name)];
	if (!Icon) return <span>{name}</span>;
	return <Icon size={20} />;
};
